import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import DiscardableForm from '../../generic/DiscardableForm';
import { targetSupplierShape } from '../../prop-types';

function TargetSupplierForm({ model }) {
  const { name, creditorNumber } = model;

  const inputProps = { readOnly: true };

  return (
    <DiscardableForm>
      <Row>
        <Col>
          <FormGroup row>
            <Label sm={4} for="ma-name">
              Name
            </Label>
            <Col sm={8}>
              <Input id="ma-name" name="name" value={name} {...inputProps} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label sm={4} for="ma-creditorNumber">
              Creditor Number
            </Label>
            <Col sm={8}>
              <Input
                id="ma-creditorNumber"
                name="creditorNumber"
                value={creditorNumber}
                {...inputProps}
              />
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </DiscardableForm>
  );
}

TargetSupplierForm.propTypes = {
  model: targetSupplierShape.isRequired,
};

export default TargetSupplierForm;
